import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FixIDS } from "../../../../../../utils/fixIDS";
import { GetAll } from "../../../../../../features/admin/customer_management/Slice";
import { formatDate } from "../../../../../../utils/common";

const Customer_Report_Table = ({ setEdit, searchName }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const customerState = useSelector((state) => state.customerManagement);

  const permissions = useSelector((state) => state.auth.permissions);
  const havePermission = permissions?.includes(FixIDS.Customer_management.Edit);

  const [currentPage, setCurrentPage] = useState(1);
  const [viewModal, setViewModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  // Fetch customers from API
  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        unique_id: searchName.unique_id || "",
        email: searchName.email || "",
        organization_name: searchName.organization_name || "",
        contact_person_name: searchName.contact_person_name || "",
        customer_status_id: searchName.customer_status_id || "",
        start_date: searchName.start_date || "",
        end_date: searchName.end_date || "",
        year: searchName.year || "",
        page: page,
        per_page: customerState.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [searchName, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Active":
        return "green";
      case "In Active":
        return "red";
      case "Blocked":
        return "gray";
      default:
        return "";
    }
  };
  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                {/* <th>
                  <input type="checkbox" />
                </th> */}
                <th>Sr.No</th>
                <th>Date</th>
                <th>Customer ID</th>
                <th>Name</th>
                <th>Company Name</th>
                <th>Customer Type</th>
                <th>GST No.</th>
                <th>Contact Person</th>
                <th>Email</th>
                <th>Contact No.</th>
                <th>No. Of Tests</th>
               
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(customerState.data) &&
              customerState.data.length > 0 ? (
                customerState.data.map((row, index) => (
                  <tr key={index}>
                    <td>
                      {(currentPage - 1) *
                        (customerState?.per_page ||
                          customerState?.data?.length ||
                          0) +
                        index +
                        1}
                    </td>
                      <td>{formatDate(row?.createdAt) || "-"}</td>

                      <td>{row?.unique_id || "-"}</td>
                      <td>{row?.name || "-"}</td>
                   
                    <td>
                      {row?.Organization_Detail?.organization_name || "-"}
                    </td>
                    <td>{row?.Customer_Type?.name || "-"}</td>
                    <td>{row?.Organization_Detail?.gst_no || "-"}</td>
                    <td>
                      {row?.Organization_Detail?.contact_person_name || "-"}
                    </td>
                    <td>{row?.email || "-"}</td>
                    <td>{row?.contact_no || "-"}</td>
                    <td>{row?.Sample_Managements?.length || 0}</td>
                   
                    <td
                      className={`status ${getStatusClass(
                        row?.Customer_Status?.name,
                      )}`}
                    >
                      {row?.Customer_Status?.name || "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing{" "}
            {(customerState.current_page - 1) * customerState.per_page + 1} To{" "}
            {Math.min(
              customerState.current_page * customerState.per_page,
              customerState.total,
            )}{" "}
            Of {customerState.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={customerState.current_page}
            totalPages={customerState.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Customer_Report_Table;
